import { render, staticRenderFns } from "./UserBeaconSettings.vue?vue&type=template&id=77b4e6c0&scoped=true"
import script from "./UserBeaconSettings.vue?vue&type=script&lang=js"
export * from "./UserBeaconSettings.vue?vue&type=script&lang=js"
import style0 from "./UserBeaconSettings.vue?vue&type=style&index=0&id=77b4e6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4e6c0",
  null
  
)

export default component.exports